<template>
  <div class="product-options-style">
    <div class="setting-item clearFloat">
      <el-popover
        ref="previewPopover"
        popper-class="previewPopover"
        placement="left"
        title=""
        trigger="hover"
        :visible-arrow="false"
        :disabled="disablePreview"
      >
        <img style="width: 100%; height: 100%" :src="previewSrc" />
        <div slot="reference" class="content">
          <swiper :options="swiperOptions" v-if="swiperLen > 0">
            <swiper-slide v-for="idx in swiperLen" :key="idx">
              <ul class="product-styles">
                <li
                  class="product-style-item"
                  v-for="(style, index) in productStyles.slice(
                    showLen * (idx - 1),
                    showLen * idx > productStyles.length ? productStyles.length : showLen * idx
                  )"
                  :class="
                    (options.encId && options.encId === style.options.encId) ||
                    (!options.encId && !style.options.encId && options.styleId === style.options.styleId)
                      ? 'active'
                      : ''
                  "
                  :key="index"
                >
                  <div
                    class="product-img-box"
                    @click="changeproductStyle(style.options, index, idx)"
                    @mouseenter="setMouseEnter"
                    @mouseout="setMouseOut"
                  >
                    <img
                      :src="style.options.cover ? style.options.cover : style.cover ? style.cover : defaultImg"
                      alt=""
                    />
                    <span class="checked-box" v-if="request_prefix !== 'bigScreen'">
                      <i class="icon-checked"></i>
                    </span>
                  </div>
                  <p class="fs14 overflowHid1">{{ style.name }}</p>
                </li>
              </ul>
            </swiper-slide>
          </swiper>
          <div class="swiper-button swiper-button-prev" v-if="productStyles.length > showLen"></div>
          <div class="swiper-button swiper-button-next" v-if="productStyles.length > showLen"></div>
        </div>
      </el-popover>
    </div>
    <styles-list
      v-if="showAllStyle"
      :showDialog.sync="showAllStyle"
      :typeId="typeId"
      :styleTypeName="styleTypeName"
      :localStylesLen="localStylesLen"
      :allStyles="productStyles"
      styleType="product"
      :activeIndex="activeIndex"
      :options="options"
      @changeStyle="changeproductStyle"
    ></styles-list>
  </div>
</template>

<script>
import instance from "../../../interceptor"
import stylesList from "./styles-list"
import { getSystemModulesList, getSyetemModuleJson, getSubPageModulesList } from "@/utils/initEv.js"
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper"
import { findTabs, hidePreviewStyle } from "utils"
import { deepCloneAndFreeze } from "utils/revork"
import { compareIds } from "../../../utils/event/animate"
import { home_select_children } from "materials/select/menus/index.js"
import { CATEGORY_MODE } from "@/consts"

export default {
  name: "product-options-style",
  components: {
    stylesList,
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    styleOptions: {
      type: Object
    }
  },
  computed: {
    hasDelPermission() {
      let userPermissionCode = this.$store.state.states.userPermission || ""
      return Array.isArray(userPermissionCode) && userPermissionCode?.indexOf(12) > -1 ? true : false
    },
    typeId() {
      if (this.options.componentTypeId && this.options.innerElement !== "cxButton") {
        return this.options.componentTypeId
      }
      let menu =
        this.request_prefix === "bigScreen"
          ? this.$store.state.bigScreenMenu.menu
          : this.request_prefix === "appStage"
          ? this.$store.state.appMenu.menu
          : this.$store.state.menu.menu
      let moduleTypes = menu.moduleTypes
      let module = moduleTypes.find(item => item.name === this.styleOptions.lable)
      let typeId = module?.encId
      return typeId
    },
    productStyles: {
      get() {
        let menu =
          this.request_prefix === "bigScreen"
            ? this.$store.state.bigScreenMenu.menu
            : this.request_prefix === "appStage"
            ? this.$store.state.appMenu.menu
            : this.$store.state.menu.menu
        let styles = [],
          productStyles = [],
          cover = "",
          curModuleType = {}
        for (let i = 0; i < menu.children.length; i++) {
          if (
            menu.children[i].type === "element" ||
            menu.children[i].type === "highLevel" ||
            menu.children[i].type === "baseElement" ||
            menu.children[i].type === "chart"
          ) {
            for (let j = 0; j < menu.children[i].children.length; j++) {
              if (menu.children[i].children[j].typeId === this.typeId) {
                styles = menu.children[i].children[j].children
                this.styleTypeName = menu.children[i].children[j].name
                this.localStylesLen = menu.children[i].children[j].localStylesLen
                cover = menu.children[i].children[j].cover
                break
              }
            }
          }
        }
        styles.forEach(item => {
          productStyles.push({
            options: item.attribute?.options,
            name: item.name,
            seq:item.seq,
            title: item.title,
            typeId: item.typeId,
            cover: !item.cover && item.thumbnail ? cover : item.cover, // 针对按钮的本地样式的cover处理
            encId: item.attribute?.options.encId
          })
        })
        return productStyles
      }
    },
    showStyles() {
      return this.productStyles.length > this.showLen ? this.productStyles.slice(0, this.showLen) : this.productStyles
    },
    moreStyles() {
      return this.productStyles.length > this.showLen ? this.productStyles.slice(this.showLen) : []
    },
    swiperLen() {
      return Math.ceil(this.productStyles.length / this.showLen)
    },
    pageType() {
      return this.$store.state[this.request_prefix].type
    }
  },
  data() {
    return {
      defaultImg: require("../../../assets/images/default_image_home.png"),
      activeIndex: 0,
      activeNames: [],
      showLen: 4,
      styleImgs: [],
      showAllStyle: false,
      styleTypeName: "",
      localStylesLen: 0,
      swiperOptions: {
        loop: false,
        speed: 500,
        autoplay: false,
        navigation: {
          nextEl: ".swiper-button.swiper-button-next",
          prevEl: ".swiper-button.swiper-button-prev"
        }
      },
      previewSrc: "",
      disablePreview: true
    }
  },
  watch: {
    "options.encId": function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getProductStyles()
      }
    }
  },
  mounted() {
    this.getProductStyles()
  },
  methods: {
    async getProductStyles() {
      let menuItem = {}
      const menu =
        this.request_prefix === "bigScreen"
          ? this.$store.state.bigScreenMenu.menu
          : this.request_prefix === "appStage"
          ? this.$store.state.appMenu.menu
          : this.$store.state.menu.menu
      for (let i = 0; i < menu.children.length; i++) {
        if (
          menu.children[i].type === "element" ||
          menu.children[i].type === "highLevel" ||
          menu.children[i].type === "baseElement"
        ) {
          for (let j = 0; j < menu.children[i].children.length; j++) {
            if (menu.children[i].children[j].typeId === this.typeId) {
              menuItem = menu.children[i].children[j]
              break
            }
          }
        }
      }

      if (this.pageType === "listPage" && (menuItem.type === "cxGaphic" || menuItem.type === "cxSystemText")) {
        await getSubPageModulesList.call(this, this.typeId, this.$store.state.states.getDataPageIds.engineInstanceId, menuItem.type)
      } else {
        await getSystemModulesList.call(this, this.typeId)
      }
    },
    delComponent(param) {
      const self = this
      if (param.encId) {
        this.$confirm("确认删除吗？", "", {
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          showClose: false,
          dangerouslyUseHTMLString: "<p>确认删除吗？</p>",
          iconClass: "bigScreen_confirm_icon el-icon-warning",
          cancelButtonClass: "bigScreen_confirm_cancel_button",
          confirmButtonClass: "bigScreen_confirm_button",
          customClass: "bigScreen_confirm custom_warning_dialog"
        })
          .then(() => {
            instance
              .post(`v2/${param.encId}/remove`)
              .then(() => {
                getSystemModulesList.call(this, this.typeId)
              })
              .catch(err => {})
          })
          .catch(() => {})
      }
    },
    // 切换样式后 查看当前布局高度是否需要修改
    changeCellSize(data) {
      // 根据ids 查找当前选中组件的布局
      let activeCell = document.getElementsByClassName("active-layout-cell-container")[0]
      if (!activeCell) {
        return
      }
      let activeLayoutIndex = activeCell.getAttribute("layoutindex")
      let parentLayoutIndex = activeLayoutIndex.split("_")
      let curIndex = parentLayoutIndex[parentLayoutIndex.length - 1]
      parentLayoutIndex.pop()

      let parentLayout = this.getAttrById(
        this.$store.state[this.request_prefix],
        {
          container_id: data.container_id,
          pageLayoutId: parentLayoutIndex.join("_")
        },
        "pageLayout"
      )
      let curCellIsCol = parentLayout.layout.cols && parentLayout.layout.cols.length > 0 ? true : false
      let activeLayout = curCellIsCol ? parentLayout.layout.cols[curIndex] : parentLayout.layout.rows[curIndex]
      let ultimateHeight = curCellIsCol ? Math.max(data.height, activeLayout.options.height) : data.height
      // 如果当前为col  兄弟元素的高度一起撑高
      if (curCellIsCol) {
        parentLayout.layout.cols.forEach((layout, index) => {
          layout.options.height = ultimateHeight
        })
      } else {
        parentLayout.layout.rows.forEach((layout, index) => {
          if (index == curIndex) {
            layout.options.height = ultimateHeight
          }
        })
      }
      // 当高度大于父元素高度的时候，单独处理
      parentLayoutIndex = parentLayoutIndex.join("_")
      this.setParentLayoutH(parentLayoutIndex, curIndex)
    },
    // 设置子元素的高度
    setChildLayoutH(editProp, child) {
      if (child.layout.rows.length === 0 && child.layout.cols.length === 0) {
        // 没有子元素啦
        return
      }
      let curCellIsRow = child.layout.rows.length > 0 ? true : false
      let layout = curCellIsRow ? child.layout.rows : child.layout.cols
      layout.forEach(item => {
        item.options.height = item.options.height * editProp
        this.setChildLayoutH(editProp, item)
      })
    },
    // 设置父元素的高度
    setParentLayoutH(parentId, curIndex) {
      let parentH = 0
      let ids = parentId.split("_")
      let lastIndex = parseInt(ids[ids.length - 1])
      let parentLayout = this.getAttrById.call(
        this,
        this.$store.state[this.request_prefix],
        { container_id: this.id, pageLayoutId: parentId },
        "pageLayout"
      ).layout
      if (parentLayout.rows.length > 0) {
        parentLayout.rows.forEach(item => {
          parentH += parseFloat(item.options.height)
        })
      } else if (parentLayout.cols.length > 0) {
        parentH = parentLayout.cols[curIndex].options.height
        parentLayout.cols.forEach((item, index) => {
          if (index === curIndex) {
            return
          }
          let editProp = parentH / item.options.height
          item.options.height = parentH
          this.setChildLayoutH(editProp, item)
        })
      } else {
        return
      }
      this.$changeOptionsEV(
        parentH,
        "height",
        false,
        "",
        {
          container_id: this.id,
          pageLayoutId: parentId
        },
        true
      )

      let newIds = parentId.split("_")
      newIds.splice(newIds.length - 1, 1)
      if (newIds.length > 0) {
        newIds = newIds.join("_")
        this.setParentLayoutH(newIds, lastIndex)
      }
    },
    async changeproductStyle(style, index, idx) {
      if (typeof index !== undefined) {
        if (idx) {
          this.activeIndex = this.showLen * (idx - 1) + index
        } else {
          this.activeIndex = index
        }
      }
      let tmpData
      let ids = this.$store.state.states.activeID
      let swiperId = ids.hasOwnProperty("swiperContent_id") ? { ...ids, swiperContent_id: null } : ids
      let curOptions = swiperId ? this.$getOptions(swiperId) : this.$getOptions()
      this.$addHistory({
        type: "update",
        stateType: "updateRect",
        payload: {
          container_id: ids.container_id,
          rect_id: ids.rect_id
        },
        before: this.getQuickShot()
      })
      if (!style.componentTypeId) {
        // 请新求回来的数据没有添加初始配置
        style.componentTypeId = curOptions.componentTypeId
        style.componentTypeName = curOptions.componentTypeName
      }
      if (!style.isDefaultComponent) {
        // 上传到服务器的系统样式
        const _attribute = await getSyetemModuleJson(style.encId)
        if (_attribute.options && _attribute.options.innerElement === "cxButton") {
          // 处理脏数据  按钮多出来的cover
          delete _attribute.options.cover
        }
        tmpData = _attribute.options
        tmpData.rect_id = _attribute.rect_id
        tmpData.shape = _attribute.shape
        tmpData.isSystemComponent = true
        tmpData.isIndependenceComponent = style.type === "swiperComponent" ? false : true
        tmpData.componentTypeId = style.componentTypeId
        tmpData.componentTypeName = style.componentTypeName
        tmpData.encId = style.encId
        tmpData.name = style.name
        tmpData.isDefaultComponent = false
        // 用来记录列表页手动切换的样式
        if (
          this.pageType === "listPage" &&
          (style.componentTypeName === "cxGaphic" || style.componentTypeName === "cxSystemText")
        ) {
          tmpData.encIdChanged = style.encId
        }
      } else {
        // 本地默认样式
        tmpData = JSON.parse(JSON.stringify(style))
      }
      if (tmpData.quoteComponent) {
        this.changeQuoteStyle(tmpData, curOptions)
        return
      }
      this.handleDefaultAnimate(tmpData)
      if (curOptions.quoteFrom === "cxSelect" || curOptions.innerElement === "cxTabs") {
        //  tab 引用select样式后，select切换回tab
        //  let activeIndex = curOptions.tabsList.findIndex(item=>item.name === curOptions.value)
        //  activeIndex =  activeIndex===-1 ? 0:activeIndex
        //   tab 引用select样式后，select切换回tab 激活第一个
        // let activeIndex = 0
        let newTabList = []
        curOptions.tabsList.forEach(item => {
          newTabList.push({
            name: item.name,
            content: item.name
          })
        })
        let activeIndex = curOptions.parentRectId
          ? curOptions.tabsList.findIndex(item => item.name === curOptions.value) || 0
          : 0
        if (tmpData.options) {
          tmpData.options.activeIndex = activeIndex
          tmpData.options.singleTabs = false
          tmpData.options.isPageLayoutTabs = curOptions.isPageLayoutTabs
          tmpData.options.tabsList = newTabList
          tmpData.options.isPageLayoutVerticalTabs = curOptions.isPageLayoutVerticalTabs
          tmpData.options.parentRectId = curOptions.parentRectId
          tmpData.options.singleTabs = curOptions.singleTabs
        } else {
          tmpData.activeIndex = activeIndex
          tmpData.singleTabs = false
          tmpData.isPageLayoutTabs = curOptions.isPageLayoutTabs
          tmpData.tabsList = newTabList
          tmpData.isPageLayoutTabs = curOptions.isPageLayoutTabs
          tmpData.isPageLayoutVerticalTabs = curOptions.isPageLayoutVerticalTabs
          tmpData.parentRectId = curOptions.parentRectId
          tmpData.singleTabs = curOptions.singleTabs
        }
      }
      let oldHeight = tmpData.height
      tmpData.left = curOptions.left
      tmpData.leftType = curOptions.leftType
      tmpData.top = curOptions.top
      tmpData.topType = curOptions.topType
      tmpData.margin = curOptions.margin
      tmpData.offset = curOptions.offset
      tmpData.isQuickSite = curOptions.isQuickSite
      // 自动布局组件中的属性，切换样式保持不变
      if (curOptions.elementInAutoLayoutId !== undefined && curOptions.elementInAutoLayoutId !== null) {
        if (tmpData.options) {
          tmpData.options.elementInAutoLayoutId = curOptions.elementInAutoLayoutId
          tmpData.options.path = curOptions.path
        } else {
          tmpData.elementInAutoLayoutId = curOptions.elementInAutoLayoutId
          tmpData.path = curOptions.path
        }
      }
      if(curOptions.menuName === '抽屉按钮'){
        tmpData.drawerPath = curOptions.drawerPath
      }
      // 小程序跳转特殊设置保留
      if (style.componentTypeName === "cxButton") {
        tmpData.isWxLink = curOptions.isWxLink
        tmpData.pluginName = curOptions.pluginName
        tmpData.openBlankPage = curOptions.openBlankPage
      }
      // 按钮想要保存新样式的尺寸
      if (curOptions.appId || style.componentTypeName === "cxButton") {
        tmpData.width = curOptions.width
        tmpData.widthType = curOptions.widthType
        tmpData.height = curOptions.height
        tmpData.heightType = curOptions.heightType
      }
      // 针对登录按钮，保留部分属性
      if (curOptions.loginType) {
        tmpData.loginType = curOptions.loginType
        tmpData.content = curOptions.content
        tmpData.iconSrc = curOptions.iconSrc
        tmpData.iconType = curOptions.iconType
      }
      // 弹出框按钮，保留属性
      if (curOptions.popoverPath) {
        tmpData.popoverPath = curOptions.popoverPath
        tmpData.openPopover = curOptions.openPopover
      }
      if (curOptions.popoverSourceId) {
        tmpData.popoverSourceId = curOptions.popoverSourceId
      }
      if (curOptions.businessId) {
        tmpData.businessId = curOptions.businessId
      }
      //自由布局组件在切换样式的时候保证外接数据源和原来的一致 刘娅的需求
      if (curOptions.innerElement.toLowerCase().includes("layout") || curOptions.innerElement === "swiperComponent") {
        tmpData.appId = curOptions.appId
        tmpData.noCacheComponent = curOptions.noCacheComponent
        tmpData.engineInstanceId = curOptions.engineInstanceId
        tmpData.engineInstanceAppId = curOptions.engineInstanceAppId
        tmpData.moduleId = curOptions.moduleId
        tmpData.myFetchParam = curOptions.myFetchParam
        // 还需要把列表页、详情页id带过去，不然后会造成重复创建子页面
        tmpData.detailPageId = curOptions.detailPageId
        tmpData.detailPageTemplateEncId = curOptions.detailPageTemplateEncId
        tmpData.listPageId = curOptions.listPageId
        tmpData.listPageTemplateEncId = curOptions.listPageTemplateEncId
        if (curOptions.categoryMode) {
          tmpData.categoryMode = curOptions.categoryMode
        }
        if(curOptions.categoryMode === CATEGORY_MODE.SAME) {
          tmpData.rows.splice(1)
        }
      }
      // 导航菜单在切换样式的时候保证外接数据源和原来的一致 不然跳数据中心报错
      if (curOptions.innerElement == "cxNavMenu") {
        tmpData.appId = curOptions.appId
        tmpData.moduleId = curOptions.moduleId
        tmpData.myFetchParam = curOptions.myFetchParam
      }
      if (curOptions.innerElement == "cxButton" && curOptions.hasOwnProperty("searchType")) {// 搜索内部按钮切换
        tmpData.searchType = curOptions.searchType
        tmpData.content = curOptions.content
      }
      // 切换样式保持应用名称不变 美多需求
      tmpData.name = curOptions.name
      tmpData.menuName = curOptions.menuName
      tmpData.menuIconClass = curOptions.menuIconClass
      let data = {
        ...ids,
        options: tmpData
      }
      this.$store.dispatch(this.request_prefix + "/changeAllOptions", data)
      if (
        curOptions.innerElement === "cxButton" ||
        curOptions.innerElement === "cxPagination" ||
        curOptions.innerElement === "cxTabs" ||
        curOptions.quoteFrom === "cxSelect"
      ) {
        return
      }
      // 目前只有按钮有收藏样式，后续如果有多种基本组件，则需要添加
      // 需要根据新样式的高度 是否修改布局的高度
      
      // 弹出框需要重写布局和通栏高度
      let activeCell = document.getElementsByClassName("active-layout-cell-container")?.[0]
      let cellSizeChange = true
      if(activeCell) {
        let activeLayoutIndex = activeCell.getAttribute("layoutindex")
        let parentLayoutIndex = activeLayoutIndex.split("_")
        let parentLayout = this.getAttrById(
          this.$store.state[this.request_prefix],
          {
            container_id: data.container_id,
            pageLayoutId: parentLayoutIndex[0]
          },
          "pageLayout"
        )
        if(parentLayout && parentLayout.options.popoverParams) {
          cellSizeChange = false
        }
      }
      if(cellSizeChange) {
        this.changeCellSize({
          ...ids,
          height: oldHeight
        })
      }

      // 需要重新初始化更多组件的数据
      if (curOptions.innerElement.toLowerCase().includes("layout")) {
        // 更多按钮初始化跳默认列表页 不用渲染链接
        // this.initMoreData(tmpData.listPageId)
      }
      // 搜索组件不调用rest-classify接口，需要单独监听并处理调用list-search接口
      if (curOptions.componentTypeName === "cxSystemSearch") {
        return
      }
      // 需要触发该组件的更新 updateAll代表分类也要重新请求
      this.$nextTick(() => {
        this.$eventBus.$emit(`update-layout-data-eventBus-${ids.container_id}-${ids.rect_id}`, {
          updateAll: true
        })
        if (curOptions.appId && curOptions.innerElement === "swiperComponent") {
          let nowComp = this.$event.contexts[this.request_prefix][this.$event.getIdsByStrId(ids)]
          nowComp.updateData()
        }

        if (curOptions.businessId) {
        if (this.$store.state[this.request_prefix].page.pluginName?.includes("listPagePlugin")) {
          this.$eventBus.$emit("listPage-component-init", {
            businessId: curOptions.businessId,
            type: curOptions.innerElement
          })
        }
        if (this.$store.state[this.request_prefix].page.pluginName?.includes("detailPagePlugin")) {
          this.$eventBus.$emit("detailPage-component-init", {
            businessId: curOptions.businessId,
            type: curOptions.innerElement
          })
        }
        if (this.$store.state[this.request_prefix].page.pluginName?.includes("subPagePlugin")) {
          this.$eventBus.$emit("subPage-component-init", {
            type: curOptions.innerElement + "_" + curOptions.innerElement
          })
        }
      }
      })
    },
    // 获取当前快照
    getQuickShot() {
      const { rect_id } = this.$store.state.states.activeID
      const page = this.$store.state[this.request_prefix].page
      const rect = page.children[0].children.find(rect => rect.rect_id === rect_id)
      return deepCloneAndFreeze(rect)
    },
    //  目前只做了按钮的切换样式保留动画，因为按钮可以收藏，所以不在local-style
    handleDefaultAnimate(style) {
      if (!style) {
        return
      }
      const ids = this.$store.state.states.activeID
      let animateTypes = ["pageloadAnimates", "hoverAnimates", "clickAnimates"]
      animateTypes.forEach(item => {
        if (style[item] && style[item].length > 0) {
          style[item].forEach(animateItem => {
            if (
              animateItem.animateOnSelf ||
              (compareIds(animateItem.ids, animateItem.controlIds) &&
                animateItem.passiveIds.length === 1 &&
                compareIds(animateItem.passiveIds[0], animateItem.ids))
            ) {
              animateItem.ids = { ...ids }
              animateItem.controlIds = { ...ids }
              animateItem.passiveIds = [{ ...ids }]
              delete animateItem.animateOnSelf
            }
          })
        }
      })
    },
    /**
     *
     * @param {*} listPageId
     * 由于有些样式不存在更多组件，所以用try catch
     */
    initMoreData(listPageId) {
      // 找到当前自由布局组件中更多组件的位置
      const ids = this.$store.state.states.activeID
      const { pageId } = this.$store.state.states.getDataPageIds
      const rectAttr = this.getRectAttribute(ids)
      try {
        const { directionIndex, elementInLayoutId } = findTabs(
          rectAttr,
          {
            container_id: ids.container_id,
            rect_id: ids.rect_id
          },
          "more"
        )
        let previewLink
        if (process.env.VUE_APP_MODE === "test" || process.env.NODE_ENV === "development") {
          previewLink = `//mh.chaoxing.com/mhssr/?p=${listPageId}&hp=${pageId}`
        } else {
          previewLink = `/v2/sub/${listPageId}/0/0/0/${pageId}`
        }
        if (!!previewLink) {
          let param = {
            container_id: ids.container_id,
            rect_id: ids.rect_id,
            directionIndex: directionIndex,
            elementInLayoutId: elementInLayoutId,
            option_name: "linkUrl",
            option_val: previewLink
          }
          this.$store.dispatch(this.request_prefix + "/changeTitleOptions", param)
        }
      } catch (error) {}
    },
    showAllStyles() {
      this.showAllStyle = true
    },
    setMouseEnter(ev) {
      if (hidePreviewStyle(this.options)) {
        this.disablePreview = true
        return
      }
      this.disablePreview = false
      const img = ev.target.children[0],
        width = img.naturalWidth,
        height = img.naturalHeight,
        previewPopover = document.getElementsByClassName("previewPopover")[0],
        baseSize = 616
      this.previewSrc = img.src
      if (width && height) {
        if (width > height) {
          previewPopover.style.width = `${baseSize}px`
          previewPopover.style.height = `${parseInt((height / width) * baseSize)}px`
        } else {
          previewPopover.style.height = `${baseSize}px`
          previewPopover.style.width = `${parseInt((width / height) * baseSize)}px`
        }
      } else {
        previewPopover.style.width = `${baseSize}px`
        previewPopover.style.height = `${baseSize}px`
      }
      previewPopover.style.padding = "8px"
      previewPopover.style.borderRadius = 0
      previewPopover.style.boxShadow = "0px 6px 24px 0px rgba(31, 35, 41, 0.1)"
      previewPopover.style.border = "1px solid rgba(233, 233, 233, 1)"
      this.$refs.previewPopover.updatePopper()
    },
    setMouseOut(ev) {
      if (hidePreviewStyle(this.options)) {
        return
      }
      if (
        !ev.toElement?.className.includes("product-img-box") &&
        !ev.toElement.parentElement?.className.includes("product-img-box")
      ) {
        this.disablePreview = true
      }
    },
    /* 标签组件切换成下拉组件 */
    changeQuoteStyle(tmpData, curOptions) {
      let ids = this.$store.state.states.activeID
      // 当前组件引用其他组件的样式 设置项  如tab引用下拉框的样式
      if (tmpData.quoteComponent === "cxSelect") {
        let options = JSON.parse(JSON.stringify(home_select_children[0].attribute.options))
        options.quoteFrom = "cxSelect"
        options.quoteTo = "cxTabs"
        options.left = curOptions.left
        options.leftType = curOptions.leftType
        options.top = curOptions.top
        options.topType = curOptions.topType
        options.margin = curOptions.margin
        options.offset = curOptions.offset
        options.menuName = curOptions.menuName
        options.menuIconClass = curOptions.menuIconClass
        options.tabsList = curOptions.tabsList
        options.styleId = tmpData.styleId
        options.value = curOptions.parentRectId
          ? curOptions.tabsList[curOptions.activeIndex]?.name
          : curOptions.tabsList[0]?.name
        // tab 切换到select样式后，tab激活第一个
        options.isPageLayoutTabs = curOptions.isPageLayoutTabs
        options.isPageLayoutVerticalTabs = curOptions.isPageLayoutVerticalTabs
        options.parentRectId = curOptions.parentRectId
        options.singleTabs = curOptions.singleTabs
        if (curOptions.elementInAutoLayoutId !== undefined && curOptions.elementInAutoLayoutId !== null) {
          options.elementInAutoLayoutId = curOptions.elementInAutoLayoutId
          options.path = curOptions.path
        }
        let data = {
          ...ids,
          options: options
        }
        this.$store.dispatch(this.request_prefix + "/changeAllOptions", data)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.product-styles {
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  gap: 12px;
  p {
    margin-bottom: 0;
    color: var(--textColor);
    line-height: 18px;
    font-size: 13px;
  }
  .product-img-box {
    position: relative;
    height: 85px;
    border-radius: 4px;
    background: var(--editBgColor);
    text-align: center;
    box-sizing: border-box;
    overflow: hidden;
    padding: 8px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .delete-icon {
      position: absolute;
      display: none;
      bottom: 2px;
      right: 2px;
      border-radius: 2px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      background-color: var(--iconHoverBgColor);
      color: var(--iconColor);
    }
    .checked-box {
      position: absolute;
      right: 0;
      top: 0;
      width: 24px;
      height: 24px;
      display: none;
    }
    .icon-checked {
      display: inline-block;
      width: 100%;
      height: 100%;
      background-image: url(../../../assets/images/icon-checked.png);
      background-size: 100% 100%;
      position: relative;
      z-index: 2;
    }
    .checked-box:before {
      content: "";
      position: absolute;
      top: 0;
    }
    .checked-box:before {
      left: 0;
      border-top: 12px solid var(--themeColor);
      border-right: 12px solid var(--themeColor);
      border-left: 12px solid transparent;
      border-bottom: 12px solid transparent;
    }
    &:hover {
      .delete-icon {
        display: block;
      }
    }
  }
  .product-style-item {
    width: 108px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 4px;
    &.active {
      .product-img-box {
        box-shadow: 0 0 0 2px var(--themeColor) inset;
        .checked-box {
          display: block;
        }
      }
    }
    &:not(.active) .product-img-box:hover {
      box-shadow: 0 0 0 2px var(--themeColorDisabled) inset;
    }
    &:not(.active) .product-img-box {
      box-shadow: 0 0 0 1px var(--elCollapseItemBorderColor) inset;
    }
  }
  .product-item {
    width: 100%;
    border: none;
    padding: 0;
    cursor: pointer;
  }
}
.product-options-style {
  padding: 16px;
}
.product-options-style .content {
  position: relative;
}
.product-options-style:hover .swiper-button {
  display: block;
}
.swiper-button {
  width: 14px;
  height: 46px;
  line-height: 45px;
  text-align: center;
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  border-radius: 0px 2px 2px 0px;
  color: var(--subTextColor);
  margin-top: -48px;
  display: none;
}
.swiper-button::after {
  font-size: 12px;
}
.swiper-button-prev {
  left: -14px;
}
.swiper-button-next {
  right: -14px;
}
</style>
